import ctx from '../../plugins/axios';

// eslint-disable-next-line import/no-anonymous-default-export
export default async (searchKeyword) => {
  const searchVal = searchKeyword || '';
  return await ctx.get(
    `/specialty?lilly_specialty=true&search_keyword=${encodeURI(searchVal)}`
  );
};
